<section class="product-media-library">
  <div class="product-media-library-header">
    <div class="title">
        {{ 'text_mediaLibraryTitle' | dbText }}
    </div>
    <div class="description">
        {{ 'text_mediaLibraryDescription' | dbText }}
    </div>
  </div>
  <div class="product-media-library-body">
    <div class="add-media">
      <span [class.selected]="selectedImages.length" (click)="addImagesToProduct()">{{ 'text_addMedia' | dbText }}</span>
    </div>
    <div class="media-library-list">
      <div class="product-image empty">
        <label for="file-input">
          <i class="db-icon db-icon-ds-bold-download"></i>
        </label>
        <input id="file-input"
               [accept]="fileExtensions"
               multiple
               (change)="fileChange($event.target)" type="file"/>
      </div>
      <ng-container *ngIf="!loading">
        <div class="product-image"
             (click)="selectImage(image)"
             [class.selected]="image.selected"
             [class.file]="image.media_type !== 'image'"
             *ngFor="let image of images">
          <ng-container *ngIf="image.media_type !== 'image';else imageItem">
            <i class="db-icon db-icon-ds-file-filled"></i>
            <div class="file-name-container">
              <div>{{image.title.rendered}}</div>
            </div>
          </ng-container>
          <ng-template #imageItem>
            <img [src]="image.source_url">
          </ng-template>

          <button class="ds-btn-s ds-btn-black">{{ (selectedImages.length ? 'text_choose': 'text_add') | dbText }}</button>
          <div class="actions-container" *ngIf="!selectedImages.length">
            <div class="delete-action" (click)="removeItem(image.id)">
              <i class="db-icon db-icon-ds-remove-outline"></i>
            </div>
          </div>
        </div>
      </ng-container>

      <db-loading-screen [ngClass]="{'hidden':!loading}"></db-loading-screen>
    </div>
  </div>
</section>
